// extracted by mini-css-extract-plugin
module.exports = {"PublicPage":"PublicPage_PublicPage__6wCM3"};